import { render, staticRenderFns } from "./MeetingPrintableReportDescription.vue?vue&type=template&id=672c7df8&"
import script from "./MeetingPrintableReportDescription.vue?vue&type=script&lang=js&"
export * from "./MeetingPrintableReportDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports